import {
  iniReader,
  COLOR_BAR_CONFIG,
  FLATCOLOR,
  STEEPCOLOR,
  isEqual,
  isDefined,
  isDataValid,
  toNumber,
  MAJMEDIANMODES,
  isDataNotMinus1000,
  INVALID_1000,
  initArray,
  forgeDeepCopy,
  FILES
} from "../shared/index";
import Decimal from "decimal.js";

import QSConfig from "../config/qs";
import fileSys from "../../fileoprators/fileSystem";
import { objectCopy } from "../../shared/utils";
import { paramNormal } from "../../shared/filters";
const CNT = 9;
// 形态因子数据初始化 ---- 0.Q 1.P-VAL  2.E 3.ecc

// 角膜数据初始化
export const BASEPARAMS = {
  K1: {
    section: "CorneaFront",
    key: "K1",
    label: "txtK1",
    value: INVALID_1000,
    directMinus: true
  },
  K2: {
    section: "CorneaFront",
    key: "K2",
    label: "txtK2",
    value: INVALID_1000,
    directMinus: true
  },
  Rf: {
    section: "CorneaFront",
    key: "Rf",
    label: "txtRf",
    value: INVALID_1000,
    directMinus: true
  },
  Rs: {
    section: "CorneaFront",
    key: "Rs",
    label: "txtRs",
    value: INVALID_1000,
    directMinus: true
  },
  Rh: {
    section: "CorneaFront",
    key: "Rh",
    label: "txtRh",
    value: INVALID_1000,
    directMinus: true
  },
  Rv: {
    section: "CorneaFront",
    key: "Rv",
    label: "txtRv",
    value: INVALID_1000,
    directMinus: true
  },
  Km: {
    section: "CorneaFront",
    key: "Km",
    label: "txtKm",
    value: INVALID_1000,
    directMinus: true
  },
  Rm: {
    section: "CorneaFront",
    key: "Rm",
    label: "txtRm",
    value: INVALID_1000,
    directMinus: true
  },
  Astig: {
    section: "CorneaFront",
    key: "Astig",
    label: "txtAstig",
    value: INVALID_1000,
    directMinus: true
  },
  Kmax: {
    section: "CorneaFront",
    key: "Kmax",
    label: "txtKmax",
    value: INVALID_1000,
    directMinus: true
  },
  Rmin: {
    section: "CorneaFront",
    key: "Rmin",
    label: "txtRmin",
    value: INVALID_1000,
    directMinus: true
  },
  RminX: {
    section: "CorneaFront",
    key: "RminX",
    label: "",
    value: INVALID_1000,
    directMinus: true
  },
  RminY: {
    section: "CorneaFront",
    key: "RminY",
    label: "",
    value: INVALID_1000,
    directMinus: true
  },
  PachyApexZ: {
    section: "CorneaPachy",
    key: "PachyApexZ",
    label: "txtApex",
    value: INVALID_1000,
    directMinus: true
  },
  PachyApexX: {
    section: "CorneaPachy",
    key: "PachyApexX",
    label: "txtApexX",
    value: INVALID_1000,
    directMinus: true
  },
  PachyApexY: {
    section: "CorneaPachy",
    key: "PachyApexY",
    label: "txtApexY",
    value: INVALID_1000,
    directMinus: true
  },
  PupilCenterZ: {
    section: "CorneaPachy",
    key: "PupilCenterZ",
    label: "txtPupilCenter",
    value: INVALID_1000,
    directMinus: true
  },
  PupilCenterX: {
    section: "CorneaPachy",
    key: "PupilCenterX",
    label: "txtPupilCenterX",
    value: INVALID_1000,
    directMinus: true
  },
  PupilCenterY: {
    section: "CorneaPachy",
    key: "PupilCenterY",
    label: "txtPupilCenterY",
    value: INVALID_1000,
    directMinus: true
  },
  LimbusCenterZ: {
    section: "CorneaPachy",
    key: "LimbusCenterZ",
    label: "txtAlpha",
    value: INVALID_1000,
    directMinus: true
  },
  LimbusCenterX: {
    section: "CorneaPachy",
    key: "LimbusCenterX",
    label: "txtAlphaX",
    value: INVALID_1000,
    directMinus: true
  },
  LimbusCenterY: {
    section: "CorneaPachy",
    key: "LimbusCenterY",
    label: "txtAlphaY",
    value: INVALID_1000,
    directMinus: true
  },
  PupilDia: {
    section: "AC_Analysis",
    key: "PupilDia",
    label: "txtPupilDia",
    value: INVALID_1000,
    directMinus: true
  },
  fCorneaDia: {
    section: "Surface",
    key: "fCorneaDia",
    label: "txtCorneaDia",
    mean: {
      key1: "fBorderMaxRVal",
      key2: "fCorneaDiaVal"
    },
    value: INVALID_1000,
    directMinus: true
  },
  AxisFlat: {
    section: "CorneaFront",
    key: "AxisFlat",
    label: "txtAxisFlat",
    value: INVALID_1000,
    directMinus: true
  },
  SRI: {
    section: "CorneaFront",
    key: "SRI",
    label: "txtSRI",
    value: INVALID_1000,
    directMinus: true
  },
  SAI: {
    section: "CorneaFront",
    key: "SAI",
    label: "txtSAI",
    value: INVALID_1000,
    directMinus: true
  },
  IS: {
    section: "CorneaFront",
    key: "IS",
    label: "txtIS",
    value: INVALID_1000,
    directMinus: true
  },
  KISA: {
    section: "CorneaFront",
    key: "KISA",
    label: "txtKISA",
    value: INVALID_1000,
    directMinus: true
  },
  SDP: {
    section: "CorneaFront",
    key: "SDP",
    label: "txtSDP",
    value: INVALID_1000,
    directMinus: true
  },
  DSI: {
    section: "CorneaFront",
    key: "DSI",
    label: "txtDSI",
    value: INVALID_1000,
    directMinus: true
  },
  OSI: {
    section: "CorneaFront",
    key: "OSI",
    label: "txtOSI",
    value: INVALID_1000,
    directMinus: true
  },
  CSI: {
    section: "CorneaFront",
    key: "CSI",
    label: "txtCSI",
    value: INVALID_1000,
    directMinus: true
  },
  IAI: {
    section: "CorneaFront",
    key: "IAI",
    label: "txtIAI",
    value: INVALID_1000,
    directMinus: true
  },
  KPI: {
    section: "CorneaFront",
    key: "KPI",
    label: "txtKPI",
    value: INVALID_1000,
    directMinus: true
  },
  AA: {
    section: "CorneaFront",
    key: "AA",
    label: "txtAA",
    value: INVALID_1000,
    directMinus: true
  },
  AxisSteep: {
    section: "CorneaFront",
    key: "AxisSteep",
    label: "txtAxisSteep",
    value: INVALID_1000,
    directMinus: true
  },
  EccPEQ: {
    value: INVALID_1000
  },
  elevDiff4mm: {
    value: INVALID_1000
  },
  fBorderMinR: {
    section: "Surface",
    key: "fBorderMinR",
    label: "txtBorderMinR",
    value: INVALID_1000,
    directMinus: true
  },
  fSagHeight4mm: {
    section: "Surface",
    key: "fSagheight4mm",
    value: INVALID_1000
  },
  fSagHeight8mm: {
    section: "Surface",
    key: "fSagheight8mm",
    value: INVALID_1000
  }
};
let qs = new QSConfig();
function calcMean(...args) {
  let sum = 0;
  let cnt = 0;
  args.map((val) => {
    if (isDataNotMinus1000(val)) {
      sum += val;
      cnt++;
    }
  });
  return cnt > 0 ? (sum /= cnt) : INVALID_1000;
}
//
/**
 * 根据设置返回数据
 * @param {string} data 需要转换的数字
 * @param {enum} mode 0.Q 1.P-VAL 2.E  3.ecc
 * @return {number}
 */
function calcMajMeridian(v, mode = -1) {
  if (!isDataValid(v)) {
    return INVALID_1000;
  }
  let val = toNumber(v);
  switch (mode) {
    case MAJMEDIANMODES.Q:
      val = val - 1;
      break;
    case MAJMEDIANMODES.P:
      break;
    case MAJMEDIANMODES.E:
      val = 1 - val;
      break;
    case MAJMEDIANMODES.ecc:
      val = Math.sqrt(val > 1 ? 1 - 1 / val : 1 - val);
      break;
    default:
      break;
  }
  return val;
}
/**
 * 计算曲率形态因子参数
 * @param  {...any} args nas,temp,sup,inf参数顺序不能改变
 * @return {object}
 */
const colors = {
  green: "#0f0",
  yellow: "yellow",
  red: "red"
};
class DataParams {
  constructor(casePath = null) {
    if (isDefined(casePath)) {
      this.casePath = casePath;
      const iniPath = fileSys.combinePath(casePath, FILES.acdotana);
      this.data = iniReader(iniPath);
      this.sagcurMedian = this._initDefalutMedian();
      this.majMedian = this._initDefalutMedian();
      this.frontpValOfMajMeridians = "";
      this.isShowGrayF = "";
      this.QS = objectCopy(qs.QS).values.concat();
    }
    this.params = forgeDeepCopy(BASEPARAMS);
    this.paramsDiff = forgeDeepCopy(BASEPARAMS);
    this.isQVisible = false;
  }
  getBaseParams() {
    if (isDefined(this.data)) {
      for (let id in this.params) {
        let section = this.params[id].section;
        if (isDefined(this.data[section])) {
          let key = this.params[id].key;
          if (!isDefined(this.params[id].mean) && isDataValid(this.data[section][key])) {
            this.params[id].value = toNumber(this.data[section][key]);
          } else if (isDefined(this.params[id].mean)) {
            let key1 = this.params[id].mean.key1;
            let key2 = this.params[id].mean.key2;
            if (isDataValid(this.data[section][key1]) && isDataValid(this.data[section][key2])) {
              this.params[id].value =
                toNumber(this.data[section][key1]) + toNumber(this.data[section][key2]) / 2;
            }
          }
        }
      }
    }
  }
  _initDefalutMedian() {
    let data = [];
    for (let i = 0; i < CNT; i++) {
      let obj = {
        nas: INVALID_1000,
        temp: INVALID_1000,
        sup: INVALID_1000,
        inf: INVALID_1000
      };
      obj["mean"] = INVALID_1000;
      obj["title"] = `${i + 2} mm`;
      data.push(obj);
    }
    return data.concat();
  }
  _getColor(flat, gray, index, val, flats, steeps) {
    if (isDataValid(flat)) {
      let _angle = toNumber(flat);
      if (index < 2) {
        if (Math.abs(_angle) < 45 || Math.abs(_angle) > 135) {
          flats.push(val);
          return gray === "1" ? "gray" : FLATCOLOR;
        } else {
          steeps.push(val);
          return gray === "1" ? "gray" : STEEPCOLOR;
        }
      } else if (index >= 2 && index < 4) {
        if (Math.abs(_angle) < 45 || Math.abs(_angle) > 135) {
          steeps.push(val);
          return gray === "1" ? "gray" : STEEPCOLOR;
        } else {
          flats.push(val);
          return gray === "1" ? "gray" : FLATCOLOR;
        }
      } else {
        return gray === "1" ? "gray" : "white";
      }
    }
    return gray === "1" ? "gray" : "white";
  }
  _procMedian(medians, IsShowGrayF, AxisFlat, mode) {
    let _data = this._initDefalutMedian();
    if (isDefined(medians)) {
      const { Nas, Temp, Sup, Inf } = medians;
      let nas = isDefined(Nas) ? Nas._trim("[")._trim("]").split(",") : initArray(CNT);
      let temp = isDefined(Temp) ? Temp._trim("[")._trim("]").split(",") : initArray(CNT);
      let sup = isDefined(Sup) ? Sup._trim("[")._trim("]").split(",") : initArray(CNT);
      let inf = isDefined(Inf) ? Inf._trim("[")._trim("]").split(",") : initArray(CNT);
      let nasGray =
        isDefined(IsShowGrayF) && isDefined(IsShowGrayF.Nas)
          ? IsShowGrayF.Nas._trim("[")._trim("]").split(",")
          : initArray(CNT, "0");
      let tempGray =
        isDefined(IsShowGrayF) && isDefined(IsShowGrayF.Temp)
          ? IsShowGrayF.Temp._trim("[")._trim("]").split(",")
          : initArray(CNT, "0");
      let supGray =
        isDefined(IsShowGrayF) && isDefined(IsShowGrayF.Sup)
          ? IsShowGrayF.Sup._trim("[")._trim("]").split(",")
          : initArray(CNT, "0");
      let infGray =
        isDefined(IsShowGrayF) && isDefined(IsShowGrayF.Inf)
          ? IsShowGrayF.Inf._trim("[")._trim("]").split(",")
          : initArray(CNT, "0");
      let meanGray =
        isDefined(IsShowGrayF) && isDefined(IsShowGrayF.Mean)
          ? IsShowGrayF.Mean._trim("[")._trim("]").split(",")
          : initArray(CNT, "0");
      for (let i = 0; i < CNT; i++) {
        let flats = [],
          steeps = [];
        let obj = {
          nas: calcMajMeridian(nas[i], mode),
          temp: calcMajMeridian(temp[i], mode),
          sup: calcMajMeridian(sup[i], mode),
          inf: calcMajMeridian(inf[i], mode)
        };
        obj["nascolor"] = this._getColor(AxisFlat, nasGray[i], 0, obj.nas, flats, steeps);
        obj["tempcolor"] = this._getColor(AxisFlat, tempGray[i], 1, obj.temp, flats, steeps);
        obj["supcolor"] = this._getColor(AxisFlat, supGray[i], 2, obj.sup, flats, steeps);
        obj["infcolor"] = this._getColor(AxisFlat, infGray[i], 3, obj.inf, flats, steeps);
        obj["meancolor"] = this._getColor(AxisFlat, meanGray[i], 4);
        const processArray = (arr) => {
          if (!arr || arr.length === 0) return new Decimal(0);

          return arr
            .map((num) => new Decimal(num).toDecimalPlaces(2))
            .reduce((acc, cur) => acc.plus(cur), new Decimal(0))
            .dividedBy(arr.length)
            .toDecimalPlaces(2);
        };
        const flat = processArray(flats);
        const steep = processArray(steeps);
        const safeFormat = (value) =>
          value.isNaN() ? "0.00" : value.toFixed(2) === "-1000.00" ? "--" : value.toFixed(2);

        obj["flat"] = safeFormat(flat);
        obj["steep"] = safeFormat(steep);
        obj["mean"] = calcMean(obj.nas, obj.temp, obj.sup, obj.inf);
        obj["title"] = `${i + 2} mm`;

        _data[i] = forgeDeepCopy(obj);
      }
    }
    return _data.concat();
  }
  _getMedian(medians, IsShowGrayF, mode = -1) {
    const { AxisFlat } =
      isDefined(this.data) && isDefined(this.data["CorneaFront"])
        ? this.data["CorneaFront"]
        : { AxisFlat: -1000 };
    return this._procMedian(medians, IsShowGrayF, AxisFlat, mode);
  }
  getMajMedianWithoutGray(FrontpValOfMajMeridians, IsShowGrayF, AxisFlat, mode) {
    return this._procMedian(FrontpValOfMajMeridians, IsShowGrayF, AxisFlat, mode);
  }
  getMajMedian(mode) {
    if (isDefined(this.data)) {
      const { FrontpValOfMajMeridians, IsShowGrayF } = this.data;
      this.frontpValOfMajMeridians = FrontpValOfMajMeridians;
      this.isShowGrayF = IsShowGrayF;
      this.majMedian = this._getMedian(FrontpValOfMajMeridians, IsShowGrayF, mode);
    }
  }
  _getQSColor(val, min, max, op, abs) {
    if (abs) val = Math.abs(val);

    switch (op) {
      case "<":
        if (val <= min) {
          return colors.green;
        } else if (val > max) {
          return colors.red;
        } else {
          return colors.yellow;
        }
      case "=":
        if (val < min) {
          return colors.green;
        } else if (val > max) {
          return colors.red;
        } else {
          return colors.yellow;
        }
      case ">":
        if (val < min) {
          return colors.red;
        } else if (val >= max) {
          return colors.green;
        } else {
          return colors.yellow;
        }
      default:
        break;
    }
  }
  getQS() {
    if (isDefined(this.data)) {
      const { QS } = this.data;
      if (isDefined(QS)) {
        if (isDefined(QS["HeightD"])) this.isQVisible = true;
        for (let id in this.QS) {
          const key = this.QS[id].key;
          if (isDefined(QS[key])) {
            let value = QS[key].trim();
            if (isDataValid(value)) {
              let c = this._getQSColor(
                toNumber(QS[key]),
                this.QS[id].min,
                this.QS[id].max,
                this.QS[id].op,
                this.QS[id].abs
              );
              this.QS[id].color = c;
              this.QS[id].value = toNumber(value);
              this.QS[id].label = c === colors.green ? "txtScanOK" : this.QS[id].label;
            }
          }
        }
        let arr = this.QS.filter((qs) => {
          return qs.included && qs.color === colors.red;
        });
        if (arr.length > 0) {
          this.QS[this.QS.length - 1] = {
            color: colors.red,
            label: arr[0].label
          };
        } else {
          arr = this.QS.filter((qs) => {
            return qs.included && qs.color === colors.yellow;
          });
          if (arr.length > 0) {
            this.QS[this.QS.length - 1] = {
              color: colors.yellow,
              label: arr[0].label
            };
          } else {
            this.QS[this.QS.length - 1] = {
              color: colors.green,
              label: "txtScanOK"
            };
          }
        }
      } else {
        this.procInvalidQS();
      }
    } else {
      this.procInvalidQS();
    }
  }
  procInvalidQS() {
    this.isQVisible = true;
    for (let id in this.QS) {
      this.QS[id].label = "--";
      this.QS[id].value = INVALID_1000;
      this.QS[id].color = "white";
    }
    this.QS[this.QS.length - 1] = {
      color: colors.red,
      label: "txtScanFailed"
    };
  }
  getSagCurMedian() {
    if (isDefined(this.data)) {
      const { FrontSagCurvOfMajMeridians, IsShowGrayF } = this.data;
      this.sagcurMedian = this._getMedian(FrontSagCurvOfMajMeridians, IsShowGrayF);
    }
  }
  getOneMajMedian(mm) {
    if (this.majMedian && this.majMedian.length > mm - 2) {
      return this.majMedian[mm - 2]["mean"];
    } else {
      return INVALID_1000;
    }
  }
  getOneMajMedianDiff(maj1, maj2, mm) {
    if (isDataValid(maj1["mean"][mm - 2]) && isDataValid(maj2["mean"][mm - 2])) {
      return (
        toNumber(paramNormal(maj1["mean"][mm - 2])) - toNumber(paramNormal(maj2["mean"][mm - 2]))
      );
    } else {
      return INVALID_1000;
    }
  }
  getBaseParamsDiff(params1, params2) {
    if (isDefined(params1) && isDefined(params2)) {
      for (let id in this.paramsDiff) {
        this.paramsDiff[id].value =
          isDataValid(params1[id].value) && isDataValid(params2[id].value)
            ? toNumber(paramNormal(params1[id].value)) - toNumber(paramNormal(params2[id].value))
            : INVALID_1000;
      }
    }
  }
}
export default DataParams;



// WEBPACK FOOTER //
// ./src/topography/dataGetters/params.js